/*
 * These are convenience functions for working with Google Tag Manager (GTM)
 */

const dataLayerExists = function () {
  let dataLayerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dataLayer';
  return typeof window[dataLayerName] === 'object' && Array.isArray(window[dataLayerName]);
};
const pushToDataLayer = function (data) {
  let dataLayerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataLayer';
  if (!dataLayerExists(dataLayerName)) {
    // eslint-disable-next-line no-console
    console.error('GTM Error: There is no dataLayer on this page.');
    return;
  }
  window[dataLayerName].push(data);
};
const pushAnalyticsEvent = function (eventData) {
  let dataLayerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataLayer';
  const event = {
    category: eventData.category || 'unspecified category',
    action: eventData.action || 'unspecified action',
    label: eventData.label || 'unspecified label',
    value: eventData.value || 'unspecified value'
  };
  pushToDataLayer(event, dataLayerName);
};

export { dataLayerExists, pushAnalyticsEvent, pushToDataLayer };
//# sourceMappingURL=gtm.js.map
